<template>
  <div class="wrapper">
    <div>

    <div class="card">
      <div class="card-body">
        <CRow>
          <CCol sm="5" lg="12" >
             <CRow >              
              <CCol  sm="5" lg="3" >
                <label class="mt-2"  > Tanggal User Input </label>
                 <CInput  v-model="date_start_created" type="date" />
                 <CInput  v-model="date_end_created" type="date" />
              </CCol>
            </CRow>
          </CCol>
          <CCol  sm="5" lg="3" >
            <CButton class="col-5 mt-3"  variant="outline" color="info" @click="filter()">Search</CButton>
          </CCol>
        </CRow>
      </div>
    </div>

      <CRow class="mt-3">
        <div></div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <Datatable
                    :items="items"
                    :fields="fields"
                    :meta="meta"
                    @per_page="handlePerPage"
                    @pagination="handlePagination"
                    @search="handleSearch"
                    @sort="handleSort"
                    @is_active="handleIsActive"
                    :btn_show="true"
                    :btn_edit="true"
                    :btn_deactivate="true"
                    :btn_reactivate="true"
                    :btn_delete="false"
                    @show="handleShow"
                    @edit="handleEdit"
                    @deactivate="handleDeactivate"
                    @reactivate="handleReactivate"
                  />
                </div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatables_prayer.vue";
import axios from "axios";

import prayer from "@/services/prayer";

import alertmodal from "@/views/alert/modal.vue";
import EventBus from "@/eventBus";
import store from "@/store.js";

import moment from 'moment';

const token = localStorage.getItem("token");

export default {
  name: "Prayer Tables",
  components: { Datatable, alertmodal },
  data() {
    return {
      form: {
        name: "",
        city: "",
        state: "",
        country: "",
        zone: "",
        leader: "",
      },
      largeModal: false,
      updateSubmit: false,
      fields: [
        { key: "name", label: "Name", sortable: false },
        { key: "content", label: "Content", sortable: false },
        { key: "created_at", label: "Input Date", sortable: false },
        { key: "is_responded", label: "Status", sortable: false },
        { key: "action", label: "Action", sortable: false },
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: "",
      sortBy: "created_at",
      sortByDesc: false,
      is_active: 0,
      date_start_created: "",
      date_end_created: "",
    };
  },
  mounted() {
    this.loadData();
    EventBus.$on("TABLE_UPDATE", (data) => {
      if (data) {
        this.loadData();
      }
    });
  },

  methods: {
    loadData() {
      let current_page = this.search == "" ? this.current_page : 1;
      var params = {
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? "DESC" : "ASC",
        is_active: this.is_active,
        date_start_created: this.date_start_created,
        date_end_created: this.date_end_created,
      };

      prayer
        .getPrayerDataSource(params)
        .then((res) => {
          let getData = res.data;
          this.items = getData.data;
          //this.is_active = res.is_active
          this.meta = {
            total: getData.total,
            current_page: getData.current_page,
            per_page: getData.per_page,
            from: getData.from,
            to: getData.to,
            is_active: res.is_active,
          };
        })
        .catch((err) => {
          var params = {
            title: "Error",
            mode: "danger",
            data: err.response.data.message,
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        });
    },

    filter(){
      if( this.date_start_created != '' ){this.date_start_created = moment(this.date_start_created).format ('DD/MM/YYYY');} 
      if( this.date_end_created != '' ){this.date_end_created = moment(this.date_end_created).format ('DD/MM/YYYY');} 
      this.loadData()

    },

    openShow(id) {
        this.$router.push({name:'Prayer Detail',query: {Pud:id} }) 
    },

    deactivate(id) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (Permission.indexOf("Delete tujuan") !== -1) {
          //IF ALLOW
          if (confirm("Do you really want to change status to Responded?")) {
            prayer
              .deactivate(id)
              .then((res) => {
                EventBus.$emit("TABLE_UPDATE", true);
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
      }
      //SET END
    },

    reactivate(id) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (Permission.indexOf("Delete tujuan") !== -1) {
          //IF ALLOW
          if (confirm("Do you really want to change status to pending?")) {
            department
              .reactivateJoin(id)
              .then((res) => {
                EventBus.$emit("TABLE_UPDATE", true);
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
      }
      //SET END
    },

    handlePerPage(val) {
      this.per_page = val;
      this.loadData();
    },

    handlePagination(val) {
      this.current_page = val;
      this.loadData();
    },

    handleSearch(val) {
      this.search = val;
      this.current_page = 1;
      this.loadData();
    },

    handleSort(val) {
      this.sortBy = val.sortBy;
      this.sortByDesc = val.sortDesc;
      this.loadData();
    },

    handleIsActive(val) {
      this.is_active = val;
      this.loadData();
    },

    ////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
      this.openShow(val);
    },

    handleDeactivate(val) {
      this.deactivate(val);
    },

    handleReactivate(val) {
      this.reactivate(val);
    },
  },
};
</script>
